import moment from "moment";
import { BUYER_STATES_FILTERS, DOC_TYPES, IMAGE_HOST, months } from "../constant";
import { formatBytes, replaceValueInDataSet } from "../utils";

export const buyerDataMauplator = (data) => {
  let buyer = {};
  const normalizeList = (value) => {
    if (!value) return "-";
    if (Array.isArray(value)) {
      const items = value
        .map((x) => (x == null ? "" : String(x).trim()))
        .filter(Boolean);
      return items.length ? items.join(" | ") : "-";
    }
    const items = String(value)
      .split(/[,|]/)
      .map((x) => x.trim())
      .filter(Boolean);
    return items.length ? [...new Set(items)].join(" | ") : "-";
  };
  buyer["name"] = data?.company_name ? replaceValueInDataSet(data?.company_name) : "-";
  buyer["website"] = data?.url ? replaceValueInDataSet(data?.url) : "-";
  buyer["url"] = buyer["website"];
  buyer["description"] = data?.description
    ? replaceValueInDataSet(data?.description).replaceAll(",", " ")
    : "-";
  buyer["type"] = data?.type ? replaceValueInDataSet(data?.type) : "-";
  buyer["tier"] = data?.tier ? data?.tier : "-";
  buyer["rank"] = data?.rank ? data?.rank : "-";
  buyer["state"] = data?.us_state_full ? replaceValueInDataSet(data?.us_state_full) : "-";
  buyer["country"] = data?.country ? replaceValueInDataSet(data?.country) : "-";
  buyer["location"] =
    [buyer["state"], buyer["country"]].filter((x) => x && x !== "-").join(", ") || "-";
  buyer["hq_address"] = data?.hq_address ? replaceValueInDataSet(data?.hq_address) : "-";
  buyer["user_preferred_industry"] = normalizeList(data?.user_preferred_industry_segmentation);
  buyer["user_preferred_industry_segmentation"] = buyer["user_preferred_industry"];
  buyer["tags"] = normalizeList(data?.tags);
  buyer["specialty_interests"] = data?.specialty_interests
    ? replaceValueInDataSet(data?.specialty_interests).replaceAll(",", " ")
    : "-";
  buyer["attribute_interests"] = data?.attribute_interests
    ? replaceValueInDataSet(data?.attribute_interests).replaceAll(",", " ")
    : "-";
  buyer["broad_specialty"] = data?.broad_specialty
    ? replaceValueInDataSet(data?.broad_specialty).replaceAll(",", " ")
    : "-";
  buyer["narrow_specialty"] = data?.narrow_specialty
    ? replaceValueInDataSet(data?.narrow_specialty).replaceAll(",", " ")
    : "-";
  buyer["naics_six_digit_industry"] = data?.naics_six_digit_industry
    ? replaceValueInDataSet(data?.naics_six_digit_industry).replaceAll(",", " ")
    : "-";
  buyer["products"] = data?.products ? replaceValueInDataSet(data?.products).replaceAll(",", " ") : "-";
  buyer["services"] = data?.services ? replaceValueInDataSet(data?.services).replaceAll(",", " ") : "-";
  buyer["preferred_ebitda"] = data?.preferred_ebitda
    ? replaceValueInDataSet(data?.preferred_ebitda).replaceAll(",", " ")
    : "-";
  buyer["preferred_revenue"] = data?.preferred_revenue
    ? replaceValueInDataSet(data?.preferred_revenue).replaceAll(",", " ")
    : "-";
  buyer["preferred_ev"] = data?.preferred_ev
    ? replaceValueInDataSet(data?.preferred_ev).replaceAll(",", " ")
    : "-";
  buyer["typical_equity_investments"] = data?.typical_equity_investments
    ? replaceValueInDataSet(data?.typical_equity_investments).replaceAll(",", " ")
    : "-";
  buyer["reasons_for_target"] = data?.ai_description
    ? replaceValueInDataSet(data?.ai_description)
    : "-";
  return buyer;
};

export const buyerListMauplator = (list) => {
  let buyers = [];
  list.map((item) => {
    buyers.push(buyerDataMauplator(item?.programx_output));
  });
  return buyers;
};

export const leadDataMauplator = (data) => {
  let lead = {};
  lead["name"] = data?.lead_name ? replaceValueInDataSet(data?.lead_name) : "-";
  lead["website"] = data?.url ? replaceValueInDataSet(data?.url) : "-";
  lead["state"] = data?.state ? replaceValueInDataSet(data?.state) : "-";
  lead["country"] = data?.country ? replaceValueInDataSet(data?.country) : "-";
  lead["status"] = data?.status ? replaceValueInDataSet(data?.status) : "-";
  lead["notes"] = data?.user_notes ? replaceValueInDataSet(data?.user_notes) : "-";
  return lead;
};

export const leadListManipulator = (list) => {
  let leads = [];
  list.map((item) => {
    leads.push(leadDataMauplator(item));
  });
  return leads;
};

export const investorsDataMauplator = (data) => {
  let investor = {};
  const state = BUYER_STATES_FILTERS.find((item) => item.value === data?.state);
  investor["name"] = data?.company_name ? replaceValueInDataSet(data?.company_name) : "-";
  investor["website"] = data?.url ? replaceValueInDataSet(data?.url) : "-";
  investor["description"] = data?.description
    ? replaceValueInDataSet(data?.description).replaceAll(",", " ")
    : "-";
  investor["type"] = data?.type ? replaceValueInDataSet(data?.type) : "-";
  investor["naics_six_digit_industry"] = data?.naics_six_digit_industry
    ? replaceValueInDataSet(data?.naics_six_digit_industry).replaceAll(",", " ")
    : "-";
  investor["state"] = data?.us_state_full
    ? replaceValueInDataSet(data?.us_state_full)
    : "-";
  investor["country"] = data?.country ? replaceValueInDataSet(data?.country) : "-";
  investor["broad_specialty"] = data?.broad_specialty
    ? replaceValueInDataSet(data?.broad_specialty).replaceAll(",", " ")
    : "-";
  investor["narrow_specialty"] = data?.narrow_specialty
    ? replaceValueInDataSet(data?.narrow_specialty).replaceAll(",", " ")
    : "-";
  investor["preferred_ebitda"] = data?.preferred_ebitda
    ? replaceValueInDataSet(data?.preferred_ebitda).replaceAll(",", " ")
    : "-";
  investor["preferred_revenue"] = data?.preferred_revenue
    ? replaceValueInDataSet(data?.preferred_revenue).replaceAll(",", " ")
    : "-";
  investor["preferred_ev"] = data?.preferred_ev
    ? replaceValueInDataSet(data?.preferred_ev).replaceAll(",", " ")
    : "-";
  investor["typical_equity_investments"] = data?.typical_equity_investments
    ? replaceValueInDataSet(data?.typical_equity_investments).replaceAll(",", " ")
    : "-";

  return investor;
};

export const investorListMauplator = (list) => {
  let investors = [];
  list.map((item) => {
    investors.push(investorsDataMauplator(item));
  });
  return investors;
};

export const documentsManipulator = (files) => {
  let documents = [];
  files.forEach((item) => {
    documents.push({
      id: item?.id,
      name: item?.name,
      type: DOC_TYPES[item?.doc_type] ?? "TXT",
      size: formatBytes(item?.doc_size),
      uploadedBy: item?.created_by_name,
      uploadedOn: moment(item?.created_at).format("MM/DD/YYYY"),
      downloadUrl: IMAGE_HOST + item?.path,
    });
  });

  return documents;
};

export const categorizeNotesTime = (time) => {
  const createdAt = new Date(time);
  const today = new Date();
  const timeDiffInMs = today.getTime() - createdAt.getTime();
  const diffInDays = Math.floor(timeDiffInMs / (1000 * 60 * 60 * 24));
  if (diffInDays === 0) {
    const diffInHours = Math.floor(timeDiffInMs / (1000 * 60 * 60));
    const diffInMinutes = Math.floor(timeDiffInMs / (1000 * 60)) % 60;
    if (diffInMinutes === 0) {
      return "Just now";
    } else if (diffInHours === 0) {
      return `${diffInMinutes} minutes ago`;
    } else if (diffInHours === 1) {
      return "1 hour ago";
    }
    return "Today";
  } else if (diffInDays === 1) {
    return "Yesterday";
  } else if (diffInDays <= 7) {
    return "Past 7 Days";
  } else if (createdAt.getFullYear() === today.getFullYear()) {
    return months[createdAt.getMonth()];
  } else {
    return createdAt.getFullYear().toString();
  }
};

export const notesManipulator = (files) => {
  let notes = [];
  files.forEach((item) => {
    notes.push({
      id: item?.id,
      note_title: item?.note_title,
      notes: item?.notes,
      pinned: item?.pinned ?? false,
      created_by: item?.created_by_name,
      created_at: categorizeNotesTime(item?.created),
    });
  });

  return notes;
};
